import axios from 'axios';

/**
 * Call Api for GET, PUT, DELETE
 * @param {string} method
 * @param {string} route
 * @param {*} id
 * @param {object} body
 */
export const CallApi = async (
  method,
  route,
  id,
  body,
  header,
  extraOption = {},
  source = null,
) => {
  const finalResponse = [];
  try {
    if (source) {
      extraOption['cancelToken'] = source.token;
    }
    let res = await axios({
      method: method,
      headers: { ...header, 'content-type': 'application/json' },
      url: `/api/${route}/${id}`,
      data: body,
      ...extraOption,
    });
    finalResponse.push(res.data);
  } catch (e) {
    console.log(e);
    return e;
  }
  return finalResponse;
};
